import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/my_company_members/PrivateDetailsForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { __, mapStateToProps } from '../../core/utils';
import { map } from 'lodash';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Textarea from '../../components/Textarea';
import Tags from '../../components/Tags';
import { listPossibleTags } from '../../redux/actions/general';

@reduxForm({
  form: 'my_company_members.private_details',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  user_id: state.auth.id,
  company_id: state.auth.company.id,
}))
@subscribe(Localization, 'localization')
class PrivateDetailsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_countries: [],
      possible_education_school_tags: [],
    };
  }

  componentDidMount() {
    listPossibleTags('hr', this.props.company_id).then(({ response }) => {
      this.setState({ possible_education_school_tags: response.data });
    });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const { localization } = this.props;

    const { possible_education_school_tags } = this.state;

    // const project_languages = data.project.languages;

    // const { project_languages, status } = data;

    const country_options = map(localization.countries, (country) => {
      return {
        value: country.id,
        label: country.name,
      };
    });

    const disabled = false;

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my_company_members.flyout.birth')}
              </label>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='date_of_birth'
                component={Input}
                label={__('my_company_members.flyout.date_of_birth')}
                placeholder='DD.MM.YYYY'
                numeric
                options={{
                  delimiter: '.',
                  blocks: [2, 2, 4],
                  numericOnly: true,
                }}
                hint={'DD.MM.YYYY'}
              />
            </div>
            <div className={styles.f1}>
              <Field
                name='country_of_birth_id'
                searchable={true}
                component={Select}
                label={__('my_company_members.flyout.country_of_birth')}
                // options={_.map(possible_countries, (country) => ({
                options={country_options}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='city_of_birth'
                component={Input}
                label={__('my_company_members.flyout.city_of_birth')}
              />
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my_company_members.flyout.private_data')}
              </label>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='personal_mobile'
                component={Input}
                label={__('my_company_members.flyout.personal_mobile')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='personal_phone'
                component={Input}
                label={__('my_company_members.flyout.personal_phone')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='personal_email'
                component={Input}
                label={__('my_company_members.flyout.personal_email')}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='personal_identification_number'
                component={Input}
                label={__('my_company_members.flyout.oib')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='tax_number'
                component={Input}
                label={__('my_company_members.flyout.tax_number')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='iban'
                component={Input}
                label={__('my_company_members.flyout.iban')}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='health_insurance'
                component={Input}
                label={__('my_company_members.flyout.health_insurance')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='pension_insurance'
                component={Input}
                label={__('my_company_members.flyout.pension_insurance')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='voluntary_insurance'
                component={Input}
                label={__('my_company_members.flyout.voluntary_insurance')}
              />
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my_company_members.flyout.residence')}
              </label>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='resident_country_id'
                searchable={true}
                component={Select}
                label={__('my_company_members.flyout.resident_country')}
                options={country_options}
                // callbackSetNewValue={(value) => {
                //   createNewWorksite(value);
                // }}
                placeholder={__('my_company_members.flyout.select-country')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='postal_code'
                component={Input}
                label={__('my_company_members.flyout.postal_code')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='city'
                component={Input}
                label={__('my_company_members.flyout.city')}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='address_1'
                component={Input}
                label={__('my_company_members.flyout.address_1')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='address_2'
                component={Input}
                label={__('my_company_members.flyout.address_2')}
              />
            </div>
            <div className={styles.f1}></div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my_company_members.flyout.education')}
              </label>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='education_country_id'
                searchable={true}
                component={Select}
                label={__('my_company_members.flyout.education_country')}
                options={country_options}
                // callbackSetNewValue={(value) => {
                //   createNewWorksite(value);
                // }}
                placeholder={__('my_company_members.flyout.select-country')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='education_city'
                component={Input}
                label={__('my_company_members.flyout.education_city')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='schools'
                component={Tags}
                label={__('my_company_members.flyout.education_schools')}
                options={possible_education_school_tags}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='education_level'
                component={Input}
                label={__('my_company_members.flyout.education_level')}
              />
            </div>
            <div className={styles.f1} />
            <div className={styles.f1} />
          </div>

          <Field
            disabled={disabled}
            name='comment'
            // localized={project_languages}
            component={Textarea}
            label={__('my_company_members.flyout.description')}
            maxLength={10000}
            rows={1}
            maxRows={10}
            placeholder={__('my_company_members.flyout.add-description')}
          />
        </div>
      </Form>
    );
  }
}

export default PrivateDetailsForm;
